import NavMenu from "./src/NavMenu.vue";
export default NavMenu;
